import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AvatarAdapter {
  private http = inject(HttpClient);

  getCompanyAvatar(): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${environment.apiBaseUrl}/company/avatar`);
  }

  editCompanyAvatar(payload): Observable<{ url: string }> {
    return this.http.patch<{ url: string }>(`${environment.apiBaseUrl}/company/avatar`, payload);
  }

  deleteCompanyAvatar(): Observable<any> {
    return this.http.delete(`${environment.apiBaseUrl}/company/avatar`);
  }

  getUserAvatar(id?: number): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${environment.apiBaseUrl}/company/user/${id ? `${id}/` : ''}avatar`);
  }

  editUserAvatar(payload): Observable<{ url: string }> {
    return this.http.patch<{ url: string }>(`${environment.apiBaseUrl}/company/user/avatar`, payload);
  }

  deleteUserAvatar(): Observable<any> {
    return this.http.delete(`${environment.apiBaseUrl}/company/user/avatar`);
  }
}
